var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AhaInfoBox',[_vm._v("\n  "+_vm._s(_vm.$i18nPresenter.t('Please note: This question is not scored. You can convert it into a Quiz slide by'))+"\n  "),_c('a',{staticClass:"right-col--link",on:{"click":function($event){return _vm.showSlideTypeSelectionAction()}}},[_vm._v(_vm._s(_vm.$i18nPresenter.t('changing its Type')))]),_vm._v(".\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }